export default "__VITE_ASSET__DciTe489__"